import './header.scss'
import { memo, useMemo, useCallback } from 'react'
// redux
import { useSelector } from 'react-redux'
// router
import { useLocation } from 'react-router-dom'
// services
import AuthService from '../../../modules/Auth/services/auth'
// hook
import useLive from '../../../modules/Lives/hooks/useLive'
import useRouterControl from '../../../hooks/useRouterControl'
// utils
import sendGaPush from '../../../utils/sendGaPush'
// components
import Image from '../../atoms/Image/image'
// assets
import logo from '../../../assets/images/Logo.svg'
import logoWhite from '../../../assets/images/logo-salud-continua-comfama-blanco.png'
import logoSmall from '../../../assets/images/logo-small.svg'
// icons
import { ArrowLeftIcon, CameraIcon, BellIcon } from '../../atoms/icons'
// main routes
import { currentHome } from '../nav-menu/nav-menu-routes'
import PermissionContainer from 'components/molecules/permission/permission'
import { CodesPermissions } from 'types/permissions'

const Header = props => {
	const {
		transparentHeader,
		logoColor,
		showLogo = true,
		goBack,
		controlBack,
		hamburger,
		showNotificationsOverlay,
		pendingNotification
	} = props

	// redux
	const { elementsUI } = useSelector(state => state)

	const { controllerBack } = elementsUI

	// location
	const { pathname } = useLocation()

	// hook
	const {
		liveState: { isCurrentLive },
		liveActions: { controlLive }
	} = useLive()
	const { routerControl, goBackControl } = useRouterControl()

	// services
	const isLoggedUser = AuthService.isLoggedIn(true)

	// render logo - memoizado para evitar recrear el objeto en cada render
	const renderLogo = useMemo(
		() => ({
			magenta: logo,
			white: logoWhite,
			small: logoSmall
		}),
		[]
	)

	// metrics - memoizado para evitar recrear la función en cada render
	const handleSendGaPush = useCallback(({ action = 'ClicHeader', label }) => {
		sendGaPush({ category: 'SaludContinuarediseno', action, label })
	}, [])

	// actions - memoizado para evitar recrear la función en cada render
	const handledLogo = useCallback(() => {
		if (pathname.includes('/par-q-public')) return
		handleSendGaPush({ label: 'logo' })
		routerControl({ link: isLoggedUser ? currentHome : '/' })
	}, [pathname, handleSendGaPush, routerControl, isLoggedUser])

	// memoizar función del botón de back
	const handleBackClick = useCallback(() => {
		handleSendGaPush({ label: 'ir atrás' })
		!(controlBack && controllerBack) ? goBackControl() : controllerBack()
	}, [handleSendGaPush, controlBack, controllerBack, goBackControl])

	// memoizar función del botón de live
	const handleLiveClick = useCallback(() => {
		handleSendGaPush({ label: 'envivo' })
		controlLive({ fromHead: true })
	}, [handleSendGaPush, controlLive])

	// memoizar función del botón de notificaciones
	const handleNotificationClick = useCallback(() => {
		handleSendGaPush({ label: 'notificacion' })
		showNotificationsOverlay()
	}, [handleSendGaPush, showNotificationsOverlay])

	return (
		<div className={`o-header ${transparentHeader ? 'o-header--transparent' : ''}`}>
			<div className='o-header-logo-container__logo'>
				{goBack && (
					<button className='o-header--back' onClick={handleBackClick}>
						<ArrowLeftIcon color='#EE2B7B' />
					</button>
				)}

				{showLogo && (
					<Image
						classes={`o-main-logo ${!hamburger ? 'no-margin' : ''}`}
						src={renderLogo[logoColor] || renderLogo.magenta}
						alt='Salud Continua'
						onClick={handledLogo}
						width={logoColor !== 'small' ? '140' : '70'}
						height='37'
						fit='contain'
						priority={true}
						loading='eager'
					/>
				)}
			</div>

			{isLoggedUser && !transparentHeader && logoColor !== 'small' && (
				<section className='o-header__online__cont'>
					<PermissionContainer permissionCode={CodesPermissions.EN_VIVOS}>
						<button
							className={`o-header__online ${isCurrentLive ? ' active' : ''} mr1`}
							onClick={handleLiveClick}
						>
							<div className='o-header__online-content-icon'>
								<CameraIcon />
							</div>
						</button>
					</PermissionContainer>

					<button className='o-header__online' onClick={handleNotificationClick}>
						<div className='o-header__online-content-icon'>
							{pendingNotification && pendingNotification.length > 0 && (
								<span className='o-header__online-content-icon__numbers'>
									{pendingNotification.length}
								</span>
							)}
							<BellIcon />
						</div>
					</button>
				</section>
			)}
		</div>
	)
}

export default memo(Header)
